module.exports = __webpack_public_path__ + "media/chedjudo.b3adb0d5.mp3";